import type { Option } from '@lichtblick/types';

export const removeSelectedOption = <TValue, T extends Option<TValue>>(
  items: T[] | undefined,
  selectedItem?: Option<TValue> | null,
): T[] => {
  if (!selectedItem) {
    return [...(items ?? [])];
  }

  const nextItems = [...(items ?? [])];
  const indexToRemove = nextItems.findIndex((item) => item.value === selectedItem.value);

  if (indexToRemove > -1) {
    nextItems.splice(indexToRemove, 1);
  }

  return nextItems;
};
